import { render, staticRenderFns } from "./organizationForm.vue?vue&type=template&id=104727b2"
import script from "./organizationForm.vue?vue&type=script&lang=js"
export * from "./organizationForm.vue?vue&type=script&lang=js"
import style0 from "./organizationForm.vue?vue&type=style&index=0&id=104727b2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports